import { ChevronDown } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { IMAGES } from "@/data/site";

export default function Hero() {
  const { t, scrollToId } = useApp();
  return (
    <section id="top" className="relative min-h-[92vh] flex items-center justify-center overflow-hidden">
      <img
        src={IMAGES.hero}
        alt="Villa italiana con piscina immersa nel verde"
        fetchPriority="high"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/45" />
      <div className="relative z-10 text-center text-white max-w-4xl px-6 animate-fade-up">
        <p className="text-xs md:text-sm tracking-[0.35em] uppercase text-brand-gold mb-6">Soggiorni selezionati, gestiti con cura</p>
        <h1 className="font-heading font-light text-4xl sm:text-5xl lg:text-7xl leading-[1.05]">
          {t.hero.title}
        </h1>
        <p className="mt-6 text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
          {t.hero.subtitle}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <button
            data-testid="hero-cta-properties"
            onClick={() => scrollToId("strutture")}
            className="bg-brand-white text-brand-olive hover:bg-brand-ivory transition-colors rounded-full px-8 py-3.5 font-medium"
          >
            {t.hero.cta1}
          </button>
          <button
            data-testid="hero-cta-booking"
            onClick={() => scrollToId("booking")}
            className="border border-white/70 text-white hover:bg-white hover:text-brand-olive transition-colors rounded-full px-8 py-3.5 font-medium"
          >
            {t.hero.cta2}
          </button>
        </div>
      </div>
      <button
        onClick={() => scrollToId("quick-search")}
        aria-label="Scorri verso il basso"
        className="scroll-hint absolute bottom-28 md:bottom-24 left-1/2 -translate-x-1/2 z-10 text-white/80 hover:text-white"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
}
